import { Box, Text, useMediaQuery } from '@chakra-ui/react';
import React from 'react';

const Results = ({ resultsData }: any) => {
	const [isLargerThan280] = useMediaQuery('(max-width: 280px)');

	return (
		<Box py={{ base: '20px', md: '54px' }} mx="auto" maxW="1440px" px={{ base: '16px', xl: '80px' }} textAlign={{ base: 'center', lg: 'left' }}>
			{resultsData?.topHeading && (
				<Text textAlign="center" textStyle="body2-md" color="white" mb={{ base: '8px', md: '16px' }}>
					{resultsData?.topHeading}
				</Text>
			)}

			<Text textAlign="center" color="white" mb={{ base: '10px', md: '20px' }} textStyle={{ base: 'h3', md: 'h2' }}>
				{resultsData?.centerHeading}
			</Text>

			{resultsData?.bottomHeading && (
				<Text textAlign="center" textStyle="body1-md" color="white">
					{resultsData?.bottomHeading}
				</Text>
			)}

			<Box
				mt="32px"
				gap={{ base: '24px', lg: '71px' }}
				// display="grid"
				// gridTemplateColumns={{
				// 	base: isLargerThan280 ? '1fr' : 'repeat(2,1fr)',
				// 	md: 'repeat(4,1fr)',
				// 	lg: 'repeat(4,1fr)',
				// }}
				display="flex"
				flexWrap="wrap"
				justifyContent="center"
				textAlign={{ base: 'center', md: 'start' }}
			>
				{resultsData?.data &&
					resultsData?.data?.length > 0 &&
					resultsData?.data?.map((item: any, index: number) => (
						<Box key={index} minW="170px">
							<Text
								textStyle={{ base: 'h3', md: 'h1' }}
								style={{
									color: '#fff',
									margin: '0px',
									whiteSpace: 'nowrap',
								}}
							>
								{item?.heading}
							</Text>
							<Text textStyle="body1-md" m="0px" color="#F3F2F2">
								{item?.text}
							</Text>
						</Box>
					))}
			</Box>
		</Box>
	);
};

export default Results;
